import React, { FC } from "react";
import { ModalBody } from "reactstrap";
import { ModalHeader } from "reactstrap";
import { Modal } from "reactstrap";

interface IPropsTypes {
  title: string;
  isOpen: boolean;
  size?: string;
  className?: string;
  toggle: () => void;
}

const ModalWrapper: FC<IPropsTypes> = ({
  title,
  isOpen,
  size = "lg",
  className,
  toggle,
  children,
}) => {
  const closeBtn = (
    <button className="close" onClick={toggle} type="button">
      &times;
    </button>
  );

  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      unmountOnClose={true}
      className={`modal-dialog-centered ${className}`}
      size={size}
      dir="rtl"
    >
      <ModalHeader toggle={toggle} close={closeBtn} >
        {title}
      </ModalHeader>
      <ModalBody  style={{ textAlign: "right", direction: "rtl" }}>{children}</ModalBody>
    </Modal>
  );
};

export { ModalWrapper };
